import React from "react";

const LegendSwatch = ({ color, stripeColor, id, size = 10 }) => {
  if (!stripeColor) {
    return <span style={{ width: size, height: size, borderRadius: "50%", backgroundColor: color, flexShrink: 0 }} />;
  }
  return (
    <svg width={size} height={size} viewBox="0 0 10 10" style={{ flexShrink: 0 }}>
      <defs>
        <pattern id={id} patternUnits="userSpaceOnUse" width={3} height={3}>
          <rect width={3} height={3} fill={color} />
          <line x1={0} y1={0} x2={3} y2={0} stroke={stripeColor} strokeWidth={1.5} />
        </pattern>
      </defs>
      <circle cx={5} cy={5} r={5} fill={`url(#${id})`} />
    </svg>
  );
};

export default LegendSwatch;
